import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    GetPredictionCarsParams,
    GetPredictionParams,
    GetPredictionResponse,
    GetPredictionCarsResponse,
} from '@/new-services/types/prediction'

type ApiGetPredictionResponse = Promise<AxiosResponse<GetPredictionResponse>>
type ApiGetPredictionCarsResponse = Promise<AxiosResponse<GetPredictionCarsResponse>>

export function getPrediction(params: GetPredictionParams): ApiGetPredictionResponse {
    return http.get('/dispatcher/api/prediction', { params })
}

export function getPredictionCars(params: GetPredictionCarsParams): ApiGetPredictionCarsResponse {
    return http.get('/dispatcher/api/prediction/cars', { params })
}

export default {
    getPrediction,
    getPredictionCars,
}
